// import React, { useState, useEffect } from 'react';
// import { database, ref, get, update } from '../../firebase';
// import { 
//   Wallet, 
//   Filter, 
//   RefreshCw,
//   ChevronDown,
//   ChevronUp,
//   Search,
//   Shield,
//   ShieldOff,
//   DollarSign,
//   CreditCard,
//   TrendingUp,
//   Users,X,
//   Battery
// } from 'lucide-react';

// const AllWallet = () => {
//   const [walletData, setWalletData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [walletType, setWalletType] = useState('all');
//   const [stats, setStats] = useState({
//     totalBalance: 0,
//     workingBalance: 0,
//     aurumBalance: 0,
//     fundBalance: 0,
//     blockedBalance: 0,
//     totalUsers: 0
//   });
//   const [expandedRows, setExpandedRows] = useState([]);
//   const [processingAction, setProcessingAction] = useState(null);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [adjustAmount, setAdjustAmount] = useState('');
//   const [adjustType, setAdjustType] = useState('add');
//   const [adjustWallet, setAdjustWallet] = useState('working');

//   useEffect(() => {
//     fetchWalletData();
//   }, []);

//   const fetchWalletData = async () => {
//     try {
//       setLoading(true);
      
//       const usersRef = ref(database, 'users');
//       const snapshot = await get(usersRef);
      
//       const walletArray = [];
//       let totalBalance = 0;
//       let workingBalance = 0;
//       let aurumBalance = 0;
//       let fundBalance = 0;
//       let blockedBalance = 0;
//       let totalUsers = 0;
      
//       if (snapshot.exists()) {
//         const data = snapshot.val();
//         Object.entries(data).forEach(([date, users]) => {
//           Object.entries(users).forEach(([dbKey, user]) => {
//             totalUsers++;
            
//             const userWorking = parseFloat(user.wallets?.working) || 0;
//             const userAurum = parseFloat(user.wallets?.aurum) || 0;
//             const userFund = parseFloat(user.fund?.balance) || 0;
//             const userBlocked = parseFloat(user.wallets?.blocked) || 0;
            
//             const userTotal = userWorking + userAurum + userFund + userBlocked;
            
//             totalBalance += userTotal;
//             workingBalance += userWorking;
//             aurumBalance += userAurum;
//             fundBalance += userFund;
//             blockedBalance += userBlocked;
            
//             walletArray.push({
//               id: dbKey,
//               date: date,
//               userId: user.sponsorId || dbKey,
//               userName: user.name || 'Unknown',
//               working: userWorking,
//               aurum: userAurum,
//               fund: userFund,
//               blocked: userBlocked,
//               total: userTotal,
//               status: user.walletStatus || 'active',
//               isActive: user.status === 'active',
//               packages: user.packages || []
//             });
//           });
//         });
//       }
      
//       walletArray.sort((a, b) => b.total - a.total);
      
//       setWalletData(walletArray);
//       setStats({
//         totalBalance,
//         workingBalance,
//         aurumBalance,
//         fundBalance,
//         blockedBalance,
//         totalUsers
//       });
//     } catch (error) {
//       console.error('Error fetching wallet data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const toggleWalletStatus = async (dbKey, date, currentStatus) => {
//     try {
//       setProcessingAction(dbKey);
//       const newStatus = currentStatus === 'blocked' ? 'active' : 'blocked';
      
//       await update(ref(database, `users/${date}/${dbKey}`), {
//         walletStatus: newStatus,
//         walletUpdatedAt: new Date().toISOString(),
//         walletUpdatedBy: 'admin'
//       });
      
//       // Update local state
//       setWalletData(prev => prev.map(item => {
//         if (item.id === dbKey) {
//           return { ...item, status: newStatus };
//         }
//         return item;
//       }));
      
//       fetchWalletData();
      
//     } catch (error) {
//       console.error('Error updating wallet status:', error);
//     } finally {
//       setProcessingAction(null);
//     }
//   };

//   const adjustWalletBalance = async () => {
//     if (!selectedUser || !adjustAmount || parseFloat(adjustAmount) <= 0) return;
    
//     try {
//       setProcessingAction('adjust_' + selectedUser.id);
      
//       const amount = parseFloat(adjustAmount);
//       const currentBalance = selectedUser[adjustWallet] || 0;
//       let newBalance = currentBalance;
      
//       if (adjustType === 'add') {
//         newBalance = currentBalance + amount;
//       } else if (adjustType === 'subtract') {
//         newBalance = Math.max(0, currentBalance - amount);
//       } else if (adjustType === 'set') {
//         newBalance = amount;
//       }
      
//       // Update in database
//       let updatePath = '';
//       let updateData = {};
      
//       if (adjustWallet === 'working') {
//         updatePath = `users/${selectedUser.date}/${selectedUser.id}/wallets/working`;
//       } else if (adjustWallet === 'aurum') {
//         updatePath = `users/${selectedUser.date}/${selectedUser.id}/wallets/aurum`;
//       } else if (adjustWallet === 'fund') {
//         updatePath = `users/${selectedUser.date}/${selectedUser.id}/fund/balance`;
//       } else if (adjustWallet === 'blocked') {
//         updatePath = `users/${selectedUser.date}/${selectedUser.id}/wallets/blocked`;
//       }
      
//       await update(ref(database, updatePath), newBalance);
      
//       // Record transaction
//       const transactionRef = ref(database, `adminWalletAdjustments/${new Date().toISOString().split('T')[0]}`);
//       const transactionId = `ADJ${Date.now()}`;
      
//       await update(ref(database, `adminWalletAdjustments/${new Date().toISOString().split('T')[0]}/${transactionId}`), {
//         id: transactionId,
//         userId: selectedUser.userId,
//         userName: selectedUser.userName,
//         walletType: adjustWallet,
//         adjustmentType: adjustType,
//         amount: amount,
//         previousBalance: currentBalance,
//         newBalance: newBalance,
//         date: new Date().toISOString(),
//         admin: 'admin',
//         note: `Manual adjustment by admin`
//       });
      
//       // Refresh data
//       fetchWalletData();
//       setSelectedUser(null);
//       setAdjustAmount('');
      
//     } catch (error) {
//       console.error('Error adjusting wallet:', error);
//     } finally {
//       setProcessingAction(null);
//     }
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: 'USD',
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   const getWalletBadge = (type) => {
//     switch(type) {
//       case 'working':
//         return { label: 'Working', color: 'bg-blue-500/20 text-blue-400 border-blue-500/30' };
//       case 'aurum':
//         return { label: 'Aerovolt', color: 'bg-primary/20 text-primary border-primary/30' };
//       case 'fund':
//         return { label: 'AV PAY', color: 'bg-green-500/20 text-green-400 border-green-500/30' };
//       case 'blocked':
//         return { label: 'Blocked', color: 'bg-red-500/20 text-red-400 border-red-500/30' };
//       default:
//         return { label: type, color: 'bg-gray-500/20 text-gray-400 border-gray-500/30' };
//     }
//   };

//   const filterData = () => {
//     let filtered = walletData;
    
//     if (walletType !== 'all') {
//       filtered = filtered.filter(item => item.status === walletType);
//     }
    
//     if (searchTerm) {
//       const term = searchTerm.toLowerCase();
//       filtered = filtered.filter(item =>
//         item.userName?.toLowerCase().includes(term) ||
//         item.userId?.toLowerCase().includes(term)
//       );
//     }
    
//     return filtered;
//   };

//   const filteredData = filterData();

//   const toggleRowExpansion = (id) => {
//     setExpandedRows(prev =>
//       prev.includes(id)
//         ? prev.filter(rowId => rowId !== id)
//         : [...prev, id]
//     );
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-64">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-7xl mx-auto px-4">
//       <h1 className="text-2xl font-bold text-white mb-2">Wallet Management</h1>
//       <p className="text-gray-400 mb-6">View and manage all user wallets</p>

//       {/* Stats */}
//       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
//         <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
//           <div className="text-gray-400 text-xs mb-1">Total Users</div>
//           <div className="text-lg font-bold text-white">{stats.totalUsers}</div>
//         </div>
//         <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
//           <div className="text-gray-400 text-xs mb-1">Total Balance</div>
//           <div className="text-lg font-bold text-white">{formatCurrency(stats.totalBalance)}</div>
//         </div>
//         <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
//           <div className="text-gray-400 text-xs mb-1">Working Wallet</div>
//           <div className="text-lg font-bold text-blue-400">{formatCurrency(stats.workingBalance)}</div>
//         </div>
//         <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
//           <div className="text-gray-400 text-xs mb-1">Aerovolt Wallet</div>
//           <div className="text-lg font-bold text-primary">{formatCurrency(stats.aurumBalance)}</div>
//         </div>
//         <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
//           <div className="text-gray-400 text-xs mb-1">AV PAY Wallet</div>
//           <div className="text-lg font-bold text-green-400">{formatCurrency(stats.fundBalance)}</div>
//         </div>
//         <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
//           <div className="text-gray-400 text-xs mb-1">Blocked Balance</div>
//           <div className="text-lg font-bold text-red-400">{formatCurrency(stats.blockedBalance)}</div>
//         </div>
//       </div>

//       {/* Filters */}
//       <div className="card-glow p-4 mb-6 bg-gray-800/50 rounded-xl">
//         <div className="flex flex-col md:flex-row gap-4">
//           <div className="flex-1">
//             <div className="relative">
//               <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
//               <input
//                 type="text"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search by user ID or name"
//                 className="w-full pl-10 pr-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
//               />
//             </div>
//           </div>
          
//           <div className="flex gap-2">
//             <select
//               value={walletType}
//               onChange={(e) => setWalletType(e.target.value)}
//               className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white text-sm"
//             >
//               <option value="all">All Status</option>
//               <option value="active">Active Only</option>
//               <option value="blocked">Blocked Only</option>
//             </select>
            
//             <button
//               onClick={fetchWalletData}
//               className="px-4 py-2 bg-primary hover:bg-primary/80 rounded-lg text-white"
//             >
//               <RefreshCw className="h-4 w-4" />
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Desktop Table */}
//       <div className="hidden lg:block card-glow overflow-hidden mb-6 bg-gray-800/50 rounded-xl">
//         <div className="p-4 border-b border-gray-700">
//           <h2 className="text-lg font-semibold text-white">
//             User Wallets ({filteredData.length})
//           </h2>
//         </div>
        
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="bg-gray-900/50">
//               <tr className="text-sm">
//                 <th className="py-3 px-4 text-left text-gray-400">User</th>
//                 <th className="py-3 px-4 text-left text-gray-400">Working</th>
//                 <th className="py-3 px-4 text-left text-gray-400">Aerovolt</th>
//                 <th className="py-3 px-4 text-left text-gray-400">AV PAY</th>
//                 <th className="py-3 px-4 text-left text-gray-400">Blocked</th>
//                 <th className="py-3 px-4 text-left text-gray-400">Total</th>
//                 <th className="py-3 px-4 text-left text-gray-400">Status</th>
//                 <th className="py-3 px-4 text-left text-gray-400">Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-700/30">
//               {filteredData.map((item) => {
//                 const isBlocked = item.status === 'blocked';
                
//                 return (
//                   <tr key={item.id} className="hover:bg-gray-700/20">
//                     <td className="py-3 px-4">
//                       <div className="text-white font-medium">{item.userName}</div>
//                       <div className="text-xs text-gray-400">{item.userId}</div>
//                       <div className={`text-xs ${item.isActive ? 'text-green-400' : 'text-red-400'}`}>
//                         {item.isActive ? 'Active' : 'Inactive'}
//                       </div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="text-blue-400 font-bold">{formatCurrency(item.working)}</div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="text-primary font-bold">{formatCurrency(item.aurum)}</div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="text-green-400 font-bold">{formatCurrency(item.fund)}</div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="text-red-400 font-bold">{formatCurrency(item.blocked)}</div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="text-white font-bold">{formatCurrency(item.total)}</div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <span className={`inline-flex items-center px-2 py-1 rounded text-xs border ${
//                         isBlocked 
//                           ? 'bg-red-500/20 text-red-400 border-red-500/30' 
//                           : 'bg-green-500/20 text-green-400 border-green-500/30'
//                       }`}>
//                         {item.status || 'active'}
//                       </span>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="flex gap-2">
//                         <button
//                           onClick={() => toggleWalletStatus(item.id, item.date, item.status)}
//                           disabled={processingAction === item.id}
//                           className={`px-3 py-1.5 text-xs rounded-lg flex items-center gap-1 ${
//                             processingAction === item.id
//                               ? 'bg-gray-500/20 text-gray-400 cursor-not-allowed'
//                               : isBlocked
//                               ? 'bg-green-500/20 hover:bg-green-500/30 text-green-400 border border-green-500/30'
//                               : 'bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30'
//                           }`}
//                         >
//                           {processingAction === item.id ? (
//                             <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-current"></div>
//                           ) : isBlocked ? (
//                             <>
//                               <ShieldOff className="h-3.5 w-3.5" />
//                               Unblock
//                             </>
//                           ) : (
//                             <>
//                               <Shield className="h-3.5 w-3.5" />
//                               Block
//                             </>
//                           )}
//                         </button>
                        
//                         <button
//                           onClick={() => setSelectedUser(item)}
//                           className="px-3 py-1.5 text-xs bg-primary/20 hover:bg-primary/30 text-primary border border-primary/30 rounded-lg"
//                         >
//                           Adjust
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Mobile View */}
//       <div className="lg:hidden space-y-4">
//         {filteredData.map((item) => {
//           const isBlocked = item.status === 'blocked';
//           const isExpanded = expandedRows.includes(item.id);
          
//           return (
//             <div key={item.id} className="card-glow overflow-hidden bg-gray-800/50 rounded-xl">
//               <button
//                 onClick={() => toggleRowExpansion(item.id)}
//                 className="w-full p-4 flex justify-between items-center hover:bg-gray-700/50"
//               >
//                 <div className="text-left flex-1">
//                   <div className="flex justify-between items-start mb-2">
//                     <div>
//                       <div className="font-medium text-white">{item.userName}</div>
//                       <div className="text-xs text-gray-400">{item.userId}</div>
//                     </div>
//                     <div className="text-right">
//                       <div className="text-white font-bold">{formatCurrency(item.total)}</div>
//                       <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs border mt-1 ${
//                         isBlocked 
//                           ? 'bg-red-500/20 text-red-400 border-red-500/30' 
//                           : 'bg-green-500/20 text-green-400 border-green-500/30'
//                       }`}>
//                         {item.status}
//                       </span>
//                     </div>
//                   </div>
                  
//                   <div className="grid grid-cols-2 gap-2 text-sm">
//                     <div className="text-blue-400">Working: {formatCurrency(item.working)}</div>
//                     <div className="text-primary">Aerovolt: {formatCurrency(item.aurum)}</div>
//                   </div>
//                 </div>
                
//                 <div className="ml-2">
//                   {isExpanded ? (
//                     <ChevronUp className="h-4 w-4 text-primary" />
//                   ) : (
//                     <ChevronDown className="h-4 w-4 text-primary" />
//                   )}
//                 </div>
//               </button>
             
//               {isExpanded && (
//                 <div className="p-4 border-t border-gray-700">
//                   <div className="space-y-3">
//                     <div className="grid grid-cols-2 gap-3">
//                       <div>
//                         <div className="text-gray-400 text-xs mb-1">AV PAY Wallet</div>
//                         <div className="text-green-400 text-sm font-bold">{formatCurrency(item.fund)}</div>
//                       </div>
//                       <div>
//                         <div className="text-gray-400 text-xs mb-1">Blocked Balance</div>
//                         <div className="text-red-400 text-sm font-bold">{formatCurrency(item.blocked)}</div>
//                       </div>
//                       <div>
//                         <div className="text-gray-400 text-xs mb-1">User Status</div>
//                         <div className={`text-sm ${item.isActive ? 'text-green-400' : 'text-red-400'}`}>
//                           {item.isActive ? 'Active' : 'Inactive'}
//                         </div>
//                       </div>
//                     </div>
                    
//                     <div className="pt-3 border-t border-gray-700/30">
//                       <div className="grid grid-cols-2 gap-2">
//                         <button
//                           onClick={() => toggleWalletStatus(item.id, item.date, item.status)}
//                           disabled={processingAction === item.id}
//                           className={`py-2 rounded-lg flex items-center justify-center gap-2 ${
//                             processingAction === item.id
//                               ? 'bg-gray-500/20 text-gray-400 cursor-not-allowed'
//                               : isBlocked
//                               ? 'bg-green-500/20 hover:bg-green-500/30 text-green-400 border border-green-500/30'
//                               : 'bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30'
//                           }`}
//                         >
//                           {processingAction === item.id ? (
//                             <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
//                           ) : isBlocked ? (
//                             <>
//                               <ShieldOff className="h-4 w-4" />
//                               Unblock
//                             </>
//                           ) : (
//                             <>
//                               <Shield className="h-4 w-4" />
//                               Block
//                             </>
//                           )}
//                         </button>
                        
//                         <button
//                           onClick={() => setSelectedUser(item)}
//                           className="py-2 rounded-lg bg-primary/20 hover:bg-primary/30 text-primary border border-primary/30 flex items-center justify-center gap-2"
//                         >
//                           <DollarSign className="h-4 w-4" />
//                           Adjust
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>

//       {/* Adjustment Dialog */}
//       {selectedUser && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70">
//           <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full">
//             <div className="flex items-center justify-between p-6 border-b border-gray-800">
//               <h3 className="text-xl font-bold text-white">Adjust Wallet Balance</h3>
//               <button
//                 onClick={() => {
//                   setSelectedUser(null);
//                   setAdjustAmount('');
//                 }}
//                 className="text-gray-400 hover:text-white"
//                 disabled={processingAction?.startsWith('adjust_')}
//               >
//                 <X size={24} />
//               </button>
//             </div>
            
//             <div className="p-6">
//               <div className="mb-6">
//                 <h4 className="text-white font-bold mb-2">{selectedUser.userName}</h4>
//                 <p className="text-gray-400 text-sm">ID: {selectedUser.userId}</p>
//               </div>
              
//               <div className="space-y-4">
//                 <div>
//                   <label className="block text-white text-sm mb-2">Wallet Type</label>
//                   <select
//                     value={adjustWallet}
//                     onChange={(e) => setAdjustWallet(e.target.value)}
//                     className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white"
//                   >
//                     <option value="working">Working Wallet</option>
//                     <option value="aurum">Aerovolt Wallet</option>
//                     <option value="fund">AV PAY Wallet</option>
//                     <option value="blocked">Blocked Wallet</option>
//                   </select>
//                 </div>
                
//                 <div>
//                   <label className="block text-white text-sm mb-2">Adjustment Type</label>
//                   <select
//                     value={adjustType}
//                     onChange={(e) => setAdjustType(e.target.value)}
//                     className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white"
//                   >
//                     <option value="add">Add Amount</option>
//                     <option value="subtract">Subtract Amount</option>
//                     <option value="set">Set Exact Amount</option>
//                   </select>
//                 </div>
                
//                 <div>
//                   <label className="block text-white text-sm mb-2">Amount ($)</label>
//                   <input
//                     type="number"
//                     value={adjustAmount}
//                     onChange={(e) => setAdjustAmount(e.target.value)}
//                     className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white"
//                     placeholder="Enter amount"
//                     min="0"
//                     step="0.01"
//                   />
//                   <p className="text-gray-400 text-xs mt-1">
//                     Current balance: {formatCurrency(selectedUser[adjustWallet])}
//                   </p>
//                 </div>
//               </div>
              
//               <div className="flex gap-4 mt-8">
//                 <button
//                   onClick={() => {
//                     setSelectedUser(null);
//                     setAdjustAmount('');
//                   }}
//                   disabled={processingAction?.startsWith('adjust_')}
//                   className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 disabled:opacity-50 rounded-xl text-white font-bold"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={adjustWalletBalance}
//                   disabled={!adjustAmount || parseFloat(adjustAmount) <= 0 || processingAction?.startsWith('adjust_')}
//                   className="flex-1 py-3 bg-primary hover:bg-primary/80 disabled:opacity-50 rounded-xl text-white font-bold"
//                 >
//                   {processingAction?.startsWith('adjust_') ? 'Processing...' : 'Apply Adjustment'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AllWallet;


import React, { useState, useEffect } from 'react';
import { database, ref, get, update } from '../../firebase';
import { 
  Wallet, 
  Filter, 
  RefreshCw,
  ChevronDown,
  ChevronUp,
  Search,
  Shield,
  ShieldOff,
  DollarSign,
  CreditCard,
  TrendingUp,
  Users,X,
  Battery
} from 'lucide-react';

const AllWallet = () => {
  const [walletData, setWalletData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [walletType, setWalletType] = useState('all');
  const [walletFilter, setWalletFilter] = useState('all'); // New filter for specific wallet type
  const [stats, setStats] = useState({
    totalBalance: 0,
    workingBalance: 0,
    aurumBalance: 0,
    fundBalance: 0,
    blockedBalance: 0,
    totalUsers: 0
  });
  const [expandedRows, setExpandedRows] = useState([]);
  const [processingAction, setProcessingAction] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [adjustAmount, setAdjustAmount] = useState('');
  const [adjustType, setAdjustType] = useState('add');
  const [adjustWallet, setAdjustWallet] = useState('working');

  useEffect(() => {
    fetchWalletData();
  }, []);

  const fetchWalletData = async () => {
    try {
      setLoading(true);
      
      const usersRef = ref(database, 'users');
      const snapshot = await get(usersRef);
      
      const walletArray = [];
      let totalBalance = 0;
      let workingBalance = 0;
      let aurumBalance = 0;
      let fundBalance = 0;
      let blockedBalance = 0;
      let totalUsers = 0;
      
      if (snapshot.exists()) {
        const data = snapshot.val();
        Object.entries(data).forEach(([date, users]) => {
          Object.entries(users).forEach(([dbKey, user]) => {
            totalUsers++;
            
            const userWorking = parseFloat(user.wallets?.working) || 0;
            const userAurum = parseFloat(user.wallets?.aurum) || 0;
            const userFund = parseFloat(user.fund?.balance) || 0;
            const userBlocked = parseFloat(user.wallets?.blocked) || 0;
            
            const userTotal = userWorking + userAurum + userFund + userBlocked;
            
            totalBalance += userTotal;
            workingBalance += userWorking;
            aurumBalance += userAurum;
            fundBalance += userFund;
            blockedBalance += userBlocked;
            
            walletArray.push({
              id: dbKey,
              date: date,
              userId: user.sponsorId || dbKey,
              userName: user.name || 'Unknown',
              working: userWorking,
              aurum: userAurum,
              fund: userFund,
              blocked: userBlocked,
              total: userTotal,
              status: user.walletStatus || 'active',
              isActive: user.status === 'active',
              packages: user.packages || []
            });
          });
        });
      }
      
      // Sort by maximum balance of the selected wallet type, or by total if 'all'
      walletArray.sort((a, b) => b.total - a.total);
      
      setWalletData(walletArray);
      setStats({
        totalBalance,
        workingBalance,
        aurumBalance,
        fundBalance,
        blockedBalance,
        totalUsers
      });
    } catch (error) {
      console.error('Error fetching wallet data:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleWalletStatus = async (dbKey, date, currentStatus) => {
    try {
      setProcessingAction(dbKey);
      const newStatus = currentStatus === 'blocked' ? 'active' : 'blocked';
      
      await update(ref(database, `users/${date}/${dbKey}`), {
        walletStatus: newStatus,
        walletUpdatedAt: new Date().toISOString(),
        walletUpdatedBy: 'admin'
      });
      
      // Update local state
      setWalletData(prev => prev.map(item => {
        if (item.id === dbKey) {
          return { ...item, status: newStatus };
        }
        return item;
      }));
      
      fetchWalletData();
      
    } catch (error) {
      console.error('Error updating wallet status:', error);
    } finally {
      setProcessingAction(null);
    }
  };

  const adjustWalletBalance = async () => {
    if (!selectedUser || !adjustAmount || parseFloat(adjustAmount) <= 0) return;
    
    try {
      setProcessingAction('adjust_' + selectedUser.id);
      
      const amount = parseFloat(adjustAmount);
      const currentBalance = selectedUser[adjustWallet] || 0;
      let newBalance = currentBalance;
      
      if (adjustType === 'add') {
        newBalance = currentBalance + amount;
      } else if (adjustType === 'subtract') {
        newBalance = Math.max(0, currentBalance - amount);
      } else if (adjustType === 'set') {
        newBalance = amount;
      }
      
      // Update in database
      let updatePath = '';
      let updateData = {};
      
      if (adjustWallet === 'working') {
        updatePath = `users/${selectedUser.date}/${selectedUser.id}/wallets/working`;
      } else if (adjustWallet === 'aurum') {
        updatePath = `users/${selectedUser.date}/${selectedUser.id}/wallets/aurum`;
      } else if (adjustWallet === 'fund') {
        updatePath = `users/${selectedUser.date}/${selectedUser.id}/fund/balance`;
      } else if (adjustWallet === 'blocked') {
        updatePath = `users/${selectedUser.date}/${selectedUser.id}/wallets/blocked`;
      }
      
      await update(ref(database, updatePath), newBalance);
      
      // Record transaction
      const transactionRef = ref(database, `adminWalletAdjustments/${new Date().toISOString().split('T')[0]}`);
      const transactionId = `ADJ${Date.now()}`;
      
      await update(ref(database, `adminWalletAdjustments/${new Date().toISOString().split('T')[0]}/${transactionId}`), {
        id: transactionId,
        userId: selectedUser.userId,
        userName: selectedUser.userName,
        walletType: adjustWallet,
        adjustmentType: adjustType,
        amount: amount,
        previousBalance: currentBalance,
        newBalance: newBalance,
        date: new Date().toISOString(),
        admin: 'admin',
        note: `Manual adjustment by admin`
      });
      
      // Refresh data
      fetchWalletData();
      setSelectedUser(null);
      setAdjustAmount('');
      
    } catch (error) {
      console.error('Error adjusting wallet:', error);
    } finally {
      setProcessingAction(null);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const getWalletBadge = (type) => {
    switch(type) {
      case 'working':
        return { label: 'Working', color: 'bg-blue-500/20 text-blue-400 border-blue-500/30' };
      case 'aurum':
        return { label: 'Aerovolt', color: 'bg-primary/20 text-primary border-primary/30' };
      case 'fund':
        return { label: 'AV PAY', color: 'bg-green-500/20 text-green-400 border-green-500/30' };
      case 'blocked':
        return { label: 'Blocked', color: 'bg-red-500/20 text-red-400 border-red-500/30' };
      default:
        return { label: type, color: 'bg-gray-500/20 text-gray-400 border-gray-500/30' };
    }
  };

  const filterData = () => {
    let filtered = walletData;
    
    if (walletType !== 'all') {
      filtered = filtered.filter(item => item.status === walletType);
    }
    
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(item =>
        item.userName?.toLowerCase().includes(term) ||
        item.userId?.toLowerCase().includes(term)
      );
    }
    
    // Apply wallet type filter
    if (walletFilter !== 'all') {
      filtered = filtered.filter(item => item[walletFilter] > 0);
      
      // Sort by the selected wallet balance (highest first)
      filtered.sort((a, b) => b[walletFilter] - a[walletFilter]);
    } else {
      // Sort by total balance when showing all
      filtered.sort((a, b) => b.total - a.total);
    }
    
    return filtered;
  };

  const filteredData = filterData();

  const toggleRowExpansion = (id) => {
    setExpandedRows(prev =>
      prev.includes(id)
        ? prev.filter(rowId => rowId !== id)
        : [...prev, id]
    );
  };

  const getTableHeaderClass = () => {
    switch(walletFilter) {
      case 'working':
        return 'text-blue-400';
      case 'aurum':
        return 'text-primary';
      case 'fund':
        return 'text-green-400';
      case 'blocked':
        return 'text-red-400';
      default:
        return 'text-white';
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h1 className="text-2xl font-bold text-white mb-2">Wallet Management</h1>
      <p className="text-gray-400 mb-6">View and manage all user wallets</p>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
        <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
          <div className="text-gray-400 text-xs mb-1">Total Users</div>
          <div className="text-lg font-bold text-white">{stats.totalUsers}</div>
        </div>
        <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
          <div className="text-gray-400 text-xs mb-1">Total Balance</div>
          <div className="text-lg font-bold text-white">{formatCurrency(stats.totalBalance)}</div>
        </div>
        <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
          <div className="text-gray-400 text-xs mb-1">Working Wallet</div>
          <div className="text-lg font-bold text-blue-400">{formatCurrency(stats.workingBalance)}</div>
        </div>
        <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
          <div className="text-gray-400 text-xs mb-1">Aerovolt Wallet</div>
          <div className="text-lg font-bold text-primary">{formatCurrency(stats.aurumBalance)}</div>
        </div>
        <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
          <div className="text-gray-400 text-xs mb-1">AV PAY Wallet</div>
          <div className="text-lg font-bold text-green-400">{formatCurrency(stats.fundBalance)}</div>
        </div>
        {/* <div className="card-glow p-3 bg-gray-800/50 rounded-xl">
          <div className="text-gray-400 text-xs mb-1">Blocked Balance</div>
          <div className="text-lg font-bold text-red-400">{formatCurrency(stats.blockedBalance)}</div>
        </div> */}
      </div>

      {/* Filters */}
      <div className="card-glow p-4 mb-6 bg-gray-800/50 rounded-xl">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search by user ID or name"
                className="w-full pl-10 pr-4 py-2 bg-gray-900 border border-gray-700 rounded-lg text-white"
              />
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2">
            <div className="flex gap-2">
              <select
                value={walletType}
                onChange={(e) => setWalletType(e.target.value)}
                className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white text-sm"
              >
                <option value="all">All Status</option>
                <option value="active">Active Only</option>
                <option value="blocked">Blocked Only</option>
              </select>
              
              <select
                value={walletFilter}
                onChange={(e) => setWalletFilter(e.target.value)}
                className="bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white text-sm"
              >
                <option value="all">All Wallets</option>
                <option value="working">Working Wallet</option>
                <option value="aurum">Aerovolt Wallet</option>
                <option value="fund">AV PAY Wallet</option>
                <option value="blocked">Blocked Wallet</option>
              </select>
            </div>
            
            <button
              onClick={fetchWalletData}
              className="px-4 py-2 bg-primary hover:bg-primary/80 rounded-lg text-white flex items-center justify-center gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Refresh
            </button>
          </div>
        </div>
      </div>

      {/* Desktop Table */}
      <div className="hidden lg:block card-glow overflow-hidden mb-6 bg-gray-800/50 rounded-xl">
        <div className="p-4 border-b border-gray-700 flex justify-between items-center">
          <h2 className={`text-lg font-semibold ${getTableHeaderClass()}`}>
            {walletFilter === 'all' ? 'User Wallets' : `${walletFilter.charAt(0).toUpperCase() + walletFilter.slice(1)} Wallets`} 
            <span className="text-gray-400 ml-2">({filteredData.length})</span>
          </h2>
          {walletFilter !== 'all' && (
            <div className={`text-sm px-3 py-1 rounded-lg ${getWalletBadge(walletFilter).color}`}>
              Showing: {getWalletBadge(walletFilter).label}
            </div>
          )}
        </div>
        
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-900/50">
              <tr className="text-sm">
                <th className="py-3 px-4 text-left text-gray-400">User</th>
                <th className={`py-3 px-4 text-left ${walletFilter === 'working' || walletFilter === 'all' ? 'text-blue-400' : 'text-gray-400'}`}>
                  Working
                </th>
                <th className={`py-3 px-4 text-left ${walletFilter === 'aurum' || walletFilter === 'all' ? 'text-primary' : 'text-gray-400'}`}>
                  Aerovolt
                </th>
                <th className={`py-3 px-4 text-left ${walletFilter === 'fund' || walletFilter === 'all' ? 'text-green-400' : 'text-gray-400'}`}>
                  AV PAY
                </th>
                {/* <th className={`py-3 px-4 text-left ${walletFilter === 'blocked' || walletFilter === 'all' ? 'text-red-400' : 'text-gray-400'}`}>
                  Blocked
                </th> */}
                <th className="py-3 px-4 text-left text-gray-400">Total</th>
                <th className="py-3 px-4 text-left text-gray-400">Status</th>
                {/* <th className="py-3 px-4 text-left text-gray-400">Actions</th> */}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700/30">
              {filteredData.map((item) => {
                const isBlocked = item.status === 'blocked';
                const highlightClass = walletFilter !== 'all' ? 'bg-gray-700/30' : '';
                
                return (
                  <tr key={item.id} className={`hover:bg-gray-700/20 ${highlightClass}`}>
                    <td className="py-3 px-4">
                      <div className="text-white font-medium">{item.userName}</div>
                      <div className="text-xs text-gray-400">{item.userId}</div>
                      <div className={`text-xs ${item.isActive ? 'text-green-400' : 'text-red-400'}`}>
                        {item.isActive ? 'Active' : 'Inactive'}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className={`font-bold ${walletFilter === 'working' ? 'text-blue-300 text-lg' : 'text-blue-400'}`}>
                        {formatCurrency(item.working)}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className={`font-bold ${walletFilter === 'aurum' ? 'text-primary-300 text-lg' : 'text-primary'}`}>
                        {formatCurrency(item.aurum)}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className={`font-bold ${walletFilter === 'fund' ? 'text-green-300 text-lg' : 'text-green-400'}`}>
                        {formatCurrency(item.fund)}
                      </div>
                    </td>
                    {/* <td className="py-3 px-4">
                      <div className={`font-bold ${walletFilter === 'blocked' ? 'text-red-300 text-lg' : 'text-red-400'}`}>
                        {formatCurrency(item.blocked)}
                      </div>
                    </td> */}
                    <td className="py-3 px-4">
                      <div className="text-white font-bold">{formatCurrency(item.total)}</div>
                    </td>
                    <td className="py-3 px-4">
                      <span className={`inline-flex items-center px-2 py-1 rounded text-xs border ${
                        isBlocked 
                          ? 'bg-red-500/20 text-red-400 border-red-500/30' 
                          : 'bg-green-500/20 text-green-400 border-green-500/30'
                      }`}>
                        {item.status || 'active'}
                      </span>
                    </td>
                    {/* <td className="py-3 px-4">
                      <div className="flex gap-2">
                        <button
                          onClick={() => toggleWalletStatus(item.id, item.date, item.status)}
                          disabled={processingAction === item.id}
                          className={`px-3 py-1.5 text-xs rounded-lg flex items-center gap-1 ${
                            processingAction === item.id
                              ? 'bg-gray-500/20 text-gray-400 cursor-not-allowed'
                              : isBlocked
                              ? 'bg-green-500/20 hover:bg-green-500/30 text-green-400 border border-green-500/30'
                              : 'bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30'
                          }`}
                        >
                          {processingAction === item.id ? (
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-current"></div>
                          ) : isBlocked ? (
                            <>
                              <ShieldOff className="h-3.5 w-3.5" />
                              Unblock
                            </>
                          ) : (
                            <>
                              <Shield className="h-3.5 w-3.5" />
                              Block
                            </>
                          )}
                        </button>
                        
                        <button
                          onClick={() => setSelectedUser(item)}
                          className="px-3 py-1.5 text-xs bg-primary/20 hover:bg-primary/30 text-primary border border-primary/30 rounded-lg"
                        >
                          Adjust
                        </button>
                      </div>
                    </td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile View */}
      <div className="lg:hidden space-y-4">
        {filteredData.map((item) => {
          // const isBlocked = item.status === 'blocked';
          const isExpanded = expandedRows.includes(item.id);
          const highlightClass = walletFilter !== 'all' ? 'border-l-4' : '';
          const highlightColor = walletFilter === 'working' ? 'border-l-blue-500' :
                               walletFilter === 'aurum' ? 'border-l-primary' :
                               walletFilter === 'fund' ? 'border-l-green-500' :"";
                              //  walletFilter === 'blocked' ? 'border-l-red-500' : '';
          
          return (
            <div key={item.id} className={`card-glow overflow-hidden bg-gray-800/50 rounded-xl ${highlightClass} ${highlightColor}`}>
              <button
                onClick={() => toggleRowExpansion(item.id)}
                className="w-full p-4 flex justify-between items-center hover:bg-gray-700/50"
              >
                <div className="text-left flex-1">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <div className="font-medium text-white">{item.userName}</div>
                      <div className="text-xs text-gray-400">{item.userId}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-white font-bold">{formatCurrency(item.total)}</div>
                      {/* <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs border mt-1 ${
                        isBlocked 
                          ? 'bg-red-500/20 text-red-400 border-red-500/30' 
                          : 'bg-green-500/20 text-green-400 border-green-500/30'
                      }`}>
                        {item.status}
                      </span> */}
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-2 text-sm">
                    <div className={`${walletFilter === 'working' ? 'text-blue-300 font-bold' : 'text-blue-400'}`}>
                      Working: {formatCurrency(item.working)}
                    </div>
                    <div className={`${walletFilter === 'aurum' ? 'text-primary-300 font-bold' : 'text-primary'}`}>
                      Aerovolt: {formatCurrency(item.aurum)}
                    </div>
                    <div className={`${walletFilter === 'fund' ? 'text-green-300 font-bold' : 'text-green-400'}`}>
                      AV PAY: {formatCurrency(item.fund)}
                    </div>
                    {/* <div className={`${walletFilter === 'blocked' ? 'text-red-300 font-bold' : 'text-red-400'}`}>
                      Blocked: {formatCurrency(item.blocked)}
                    </div> */}
                  </div>
                </div>
                
                <div className="ml-2">
                  {isExpanded ? (
                    <ChevronUp className="h-4 w-4 text-primary" />
                  ) : (
                    <ChevronDown className="h-4 w-4 text-primary" />
                  )}
                </div>
              </button>
             
              {isExpanded && (
                <div className="p-4 border-t border-gray-700">
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <div className="text-gray-400 text-xs mb-1">User Status</div>
                        <div className={`text-sm ${item.isActive ? 'text-green-400' : 'text-red-400'}`}>
                          {item.isActive ? 'Active' : 'Inactive'}
                        </div>
                      </div>
                      <div>
                        <div className="text-gray-400 text-xs mb-1">Joined Date</div>
                        <div className="text-white text-sm">{item.date}</div>
                      </div>
                    </div>
                    
                    <div className="pt-3 border-t border-gray-700/30">
                      {/* <div className="grid grid-cols-2 gap-2">
                        <button
                          onClick={() => toggleWalletStatus(item.id, item.date, item.status)}
                          disabled={processingAction === item.id}
                          className={`py-2 rounded-lg flex items-center justify-center gap-2 ${
                            processingAction === item.id
                              ? 'bg-gray-500/20 text-gray-400 cursor-not-allowed'
                              : isBlocked
                              ? 'bg-green-500/20 hover:bg-green-500/30 text-green-400 border border-green-500/30'
                              : 'bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30'
                          }`}
                        >
                          {processingAction === item.id ? (
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
                          ) : isBlocked ? (
                            <>
                              <ShieldOff className="h-4 w-4" />
                              Unblock
                            </>
                          ) : (
                            <>
                              <Shield className="h-4 w-4" />
                              Block
                            </>
                          )}
                        </button>
                        
                        <button
                          onClick={() => setSelectedUser(item)}
                          className="py-2 rounded-lg bg-primary/20 hover:bg-primary/30 text-primary border border-primary/30 flex items-center justify-center gap-2"
                        >
                          <DollarSign className="h-4 w-4" />
                          Adjust
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Adjustment Dialog */}
      {selectedUser && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70">
          <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl max-w-md w-full">
            <div className="flex items-center justify-between p-6 border-b border-gray-800">
              <h3 className="text-xl font-bold text-white">Adjust Wallet Balance</h3>
              <button
                onClick={() => {
                  setSelectedUser(null);
                  setAdjustAmount('');
                }}
                className="text-gray-400 hover:text-white"
                disabled={processingAction?.startsWith('adjust_')}
              >
                <X size={24} />
              </button>
            </div>
            
            <div className="p-6">
              <div className="mb-6">
                <h4 className="text-white font-bold mb-2">{selectedUser.userName}</h4>
                <p className="text-gray-400 text-sm">ID: {selectedUser.userId}</p>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-white text-sm mb-2">Wallet Type</label>
                  <select
                    value={adjustWallet}
                    onChange={(e) => setAdjustWallet(e.target.value)}
                    className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white"
                  >
                    <option value="working">Working Wallet</option>
                    <option value="aurum">Aerovolt Wallet</option>
                    <option value="fund">AV PAY Wallet</option>
                    {/* <option value="blocked">Blocked Wallet</option> */}
                  </select>
                </div>
                
                <div>
                  <label className="block text-white text-sm mb-2">Adjustment Type</label>
                  <select
                    value={adjustType}
                    onChange={(e) => setAdjustType(e.target.value)}
                    className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white"
                  >
                    <option value="add">Add Amount</option>
                    <option value="subtract">Subtract Amount</option>
                    <option value="set">Set Exact Amount</option>
                  </select>
                </div>
                
                <div>
                  <label className="block text-white text-sm mb-2">Amount ($)</label>
                  <input
                    type="number"
                    value={adjustAmount}
                    onChange={(e) => setAdjustAmount(e.target.value)}
                    className="w-full bg-gray-900 border border-gray-700 rounded-lg px-3 py-2 text-white"
                    placeholder="Enter amount"
                    min="0"
                    step="0.01"
                  />
                  <p className="text-gray-400 text-xs mt-1">
                    Current balance: {formatCurrency(selectedUser[adjustWallet])}
                  </p>
                </div>
              </div>
              
              <div className="flex gap-4 mt-8">
                <button
                  onClick={() => {
                    setSelectedUser(null);
                    setAdjustAmount('');
                  }}
                  disabled={processingAction?.startsWith('adjust_')}
                  className="flex-1 py-3 bg-gray-700 hover:bg-gray-600 disabled:opacity-50 rounded-xl text-white font-bold"
                >
                  Cancel
                </button>
                <button
                  onClick={adjustWalletBalance}
                  disabled={!adjustAmount || parseFloat(adjustAmount) <= 0 || processingAction?.startsWith('adjust_')}
                  className="flex-1 py-3 bg-primary hover:bg-primary/80 disabled:opacity-50 rounded-xl text-white font-bold"
                >
                  {processingAction?.startsWith('adjust_') ? 'Processing...' : 'Apply Adjustment'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllWallet;

